import HttpClient from "../HttpClient";

export interface ServiceabilitySweepPoint {
  id: number;
  runId: string;
  cityId: number;
  cityName: string;
  lat: string;
  long: string;
  coordinates: {
    type: string;
    coordinates: [number, number]; // [long, lat]
  } | null;
  isInsidePolygon: boolean;
  enclosingAreaId: number | null;
  enclosingAreaName: string | null;
  resolvedAreaId: number | null;
  resolvedAreaName: string | null;
  resolvedViaFallback: boolean;
  isChefitServiceable: boolean;
  isBookByDishServiceable: boolean;
  isPartyServiceable: boolean;
  serviceNames: string[];
  createdAt: string;
  updatedAt: string;
}

export default class ServiceabilityMapService {
  /**
   * Fetches all serviceability-sweep points by paginating through the API
   * until a page returns fewer records than the requested limit.
   */
  async getServiceabilitySweep(): Promise<ServiceabilitySweepPoint[]> {
    const response = await HttpClient.get<ServiceabilitySweepPoint[]>(
      "/centaurus/houses/serviceability-sweep"
    );
    return response.data ?? [];
  }
}
